import { render, staticRenderFns } from "./categoriesView.vue?vue&type=template&id=59d6cede&"
import script from "./categoriesView.vue?vue&type=script&lang=js&"
export * from "./categoriesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports